import { Col, Flex, Form, Input, Row, Space, Table, Tag, Tooltip, Typography } from "antd";
import React, { useState } from "react";
import Dropzone from "../../../components/DropZone";
import { useDispatch, useSelector } from "react-redux";
import { setUploadedFiles } from "../../../store/reducers/slices/createReport.slice";
import { extractFileDetails } from "../../../api/reportDetails";
import { InboxOutlined, PaperClipOutlined, DeleteOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { setExtractedData, setExtractedDataError, setExtractedDataLoading } from "../../../store/reducers/slices/extractedData.slice";
import CustomTypography from "../../../components/common/CustomTypography";
import CustomInput from "../../../components/common/CustomInput";
import CustomButton from "../../../components/common/CustomButton";
import { showNotification } from "../../../store/reducers/slices/notification.slice";
import { render } from "@testing-library/react";

const UploadBankStatementForm = ({ name, form, isEdit, resetFields, remove, fileDetails, setCurrentFiles, mapIndex, reportDetails, resetForm, ...restField }) => {
    const [files, setFiles] = useState(reportDetails?.reportAccounts.reduce(
        emptyFiles => {
            emptyFiles.push([]);
            return emptyFiles;
        },
        [[]]
    ));
    const [passwordFiles, setPasswordFiles] = useState(reportDetails?.reportAccounts.reduce(
        emptyFiles => {
            emptyFiles.push([]);
            return emptyFiles;
        },
        [[]]
    ));
    const [extractedNestedData, setExtractedNestedData] = useState(reportDetails?.reportAccounts.reduce(
        emptyFiles => {
            emptyFiles.push([]);
            return emptyFiles;
        },
        [[]]
    ));
    const [passwords, setPasswords] = useState({});
    const [acceptedFiles, setAcceptedFiles] = useState([])
    const [showPasswordMsg, setShowPasswordMsg] = useState(false);
    const [submittedPasswords, setSubmittedPasswords] = useState(new Set());
    const [passwordRequiredFiles, setPasswordRequiredFiles] = useState([]); // Track files needing passwords
    const dispatch = useDispatch();
    const { editUploadedFiles: analysedUploadedFiles } = useSelector(({ updateReport }) => updateReport)
    const { extractedData } = useSelector(({ extractedData }) => extractedData)
    const { uploadedAccountDetails } = useSelector(({ updateReport }) => updateReport);

    const uploadFile = uploadedAccountDetails?.reportAccounts[mapIndex]?.files || [];


    console.log("FILE DETAILS>>>", fileDetails);


    const dataSources = [
        {
            key: '1',
            fileName: "-",
            pages: "-",
            transaction: "-",
            status: "-",
            authenticity: "-",
            action: "-",
        },
    ];

    const columns = [
        {
            title: 'File Name',
            dataIndex: 'originalName',
            key: 'originalName',
            width: '25%',
            ellipsis: true,
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    <span>{text}</span>
                </Tooltip>
            ),
        },
        {
            title: 'Pages',
            dataIndex: 'pageCount',
            key: 'pageCount',
            width: '10%',
            ellipsis: true,
        },
        {
            title: 'Transaction',
            dataIndex: 'txnCount',
            key: 'txnCount',
            width: '10%',
            ellipsis: true,
        },
        {
            title: (
                <>
                    Status{' '}
                    <Tooltip title={(<>
                        <p>Bank Statement file status indicates if the file was parsed successfully or not. Here’s the definition of bank statement file level status displayed in saved Report and corrective action required for unblocking the analysis in case of parsing errors:</p><br />
                        <p>
                            1. <strong>Initialising</strong> - prepration for parsing<br />
                            2. <strong>Parsing</strong> - parsing has started<br />
                            3. <strong>Parsed</strong> - file parsed successfully<br />
                            4. <strong>In review</strong> - file can be parsed but need manual intervention<br />
                            5. <strong>Not parsable</strong> - file could not be parsed for some reason.
                        </p>
                    </>)}>
                        <QuestionCircleOutlined style={{ marginLeft: 8, fontSize: '14px', color: '#666666' }} />
                    </Tooltip>
                </>
            ),
            dataIndex: 'status',
            key: 'status',
            width: '10%', ellipsis: true,
            render: (text, record) => {
                const isParsed = record.status === 'PARSED';
                const isInReview = record.status === 'IN REVIEW';
                const isInitialising = record.status === 'INITIALISING';
                const isParsing = record.status === 'PARSING';
                const isNotParsable = record.status === 'NOT PARSABLE';

                return (
                    <Tooltip placement="bottom" title={text}>
                        <Tag
                            color={isParsed ? "#F6FFED" : (isInReview ? "#E6F4FF" : (isInitialising ? "#FFF7E6" : (isParsing ? "#D9D9D9" : (isNotParsable ? "#FFF1F0" : "#F0F5FF"))))}
                            style={{
                                border: isParsed ? "1px solid #B7EB8F" : (isInReview ? "1px solid #91CAFF" : (isInitialising ? "1px solid #FFD591" : (isParsing ? "1px solid #D9D9D9" : (isNotParsable ? "1px solid #FFA39E" : "1px solid #ADC6FF"))))
                            }}
                        >
                            <Typography.Text
                                style={{
                                    color: isParsed ? "#52C41A" : (isInReview ? "#1677FF" : (isInitialising ? "#FA8C16" : (isParsing ? "#000000E0" : (isNotParsable ? "#F5222D" : "#2F54EB")))),
                                    fontWeight: 500,
                                    fontSize: "12px",
                                    lineHeight: "20px"
                                }}
                            >
                                {text}
                            </Typography.Text>
                        </Tag>
                    </Tooltip>
                );
            }
        },
        // {
        //     title: (
        //         <>
        //             Authenticity{' '}
        //             <Tooltip title={(<>
        //                 <p>Zentra runs authenticity check on PDF file properties , format  & content, to verify if the statement has been tampered with, and compute a Authenticity Rating as follows:</p><br />
        //                 <p>
        //                 <strong>FRAUD CONFIRMED</strong> - Confirmed Tempering<br /> 
        //                 <strong>FRAUD SUSPECTED</strong> - User review recommended<br />
        //                 <strong>ORIGINAL</strong> - No Tempering<br />
        //                 </p>
        //                 </>)}>
        //                 <QuestionCircleOutlined style={{ cursor: 'pointer', fontSize: '18px' }} />
        //             </Tooltip>
        //         </>
        //     ),
        //     dataIndex: 'authenticity',
        //     key: 'authenticity',
        //     width: '25%',
        //     ellipsis: true,
        //     render: (text, record) => {
        //         const isOriginal = record.authenticity === 'ORIGINAL';
        //         const isNotParsable = record.authenticity === 'FRAUD CONFIRMED' || 'FRAUD SUSPECTED' || 'UNKNOWN';

        //         return (
        //             <Tooltip placement="bottom" title={text}>
        //                 <Tag
        //                     color={isOriginal ? "#F6FFED" : (isNotParsable ? "#FFF1F0" :"#F0F5FF")}
        //                     style={{
        //                         border: isOriginal ? "1px solid #B7EB8F" :(isNotParsable ? "1px solid #FFA39E" :"1px solid #ADC6FF")
        //                     }}
        //                 >
        //                     <Typography.Text
        //                         style={{
        //                             color: isOriginal ? "#52C41A" : (isNotParsable ? "#F5222D" :"#2F54EB"),
        //                             fontWeight: 500,
        //                             fontSize: "12px",
        //                             lineHeight: "20px"
        //                         }}
        //                     >
        //                         {text}
        //                     </Typography.Text>
        //                 </Tag>
        //             </Tooltip>
        //         );
        //     }
        // },
        // {
        //     title: 'Action',
        //     dataIndex: 'action',
        //     key: 'action',
        //     ellipsis: true,
        //     render: (_, record) => (
        //         <Tooltip title="Remove">
        //             <a>Delete</a>
        //         </Tooltip>
        //     ),
        // },
    ];


    const handlePasswordChange = (e, fileName, i) => {
        console.log("Handler Of OnChange >>>", e, e.target, e.target.value, fileName);

        let value = e.target.value;
        console.log("VALUE OF TARGET", value);

        // setPasswords(prev => ({
        //     ...prev,
        //     [fileName]: value // Update password for corresponding file
        // }));

        let allFiles = files?.acceptedFiles?.map((item) => {
            return {
                ...item,
                password: value
            }
        })

        setFiles((prev) => ({
            ...prev,
            acceptedFiles: allFiles
        }))


        // setFiles((prev) => {
        //     if (!prev || !prev.acceptedFiles) return prev; // Ensure 'prev' and 'acceptedFiles' exist

        //     const updatedFiles = prev.acceptedFiles.map((file) => {
        //         if (file?.file?.path === fileName) {
        //             return {
        //                 ...file,
        //                 password: value || "", // Ensure password is always set
        //             };
        //         }
        //         return file;
        //     });

        //     // Ensure the new state object is correctly structured
        //     const updatedState = {
        //         ...prev,
        //         acceptedFiles: updatedFiles,
        //     };

        //     console.log("UPDATING ON CHANGELOG", updatedState); // Debugging after mapping
        //     return updatedState;
        // });
    };


    console.log("FILE AFTER SETTINGUP PASSWORD", files);



    const handleDelete = (fileIndex) => {
        const bankAccounts = form.getFieldValue('bankAccounts') || [];
        console.log("Delete clicked", files, bankAccounts, fileIndex);

        if (bankAccounts[mapIndex]) {

            console.log(extractedData, "extractedData")

            // if (extractedData.length === 1) {
            //     console.log("set blank array")
            //     dispatch(setExtractedData([]))
            // } else {
            let FindIndex = extractedData.findIndex((iteratore) => iteratore?.mapIndex === mapIndex);
            console.log("FIND INDEX OF ARRAY", FindIndex);

            if (FindIndex >= 0) {
                let _extractedData = [...extractedData];
                if (_extractedData[FindIndex].uploadedFiles.length > 1) {
                    const newUploadedFiles = _extractedData[FindIndex].uploadedFiles.filter((item) => item?.path?.name !== files.acceptedFiles[fileIndex]?.file?.name)
                    _extractedData[FindIndex] = {
                        ..._extractedData[FindIndex],
                        uploadedFiles: newUploadedFiles,
                    };
                } else if (_extractedData[FindIndex].uploadedFiles.length === 1) {
                    _extractedData = _extractedData.filter((item, index) => index !== FindIndex)
                    const updatedAccount = {
                        reportName: bankAccounts[mapIndex].reportName,
                        createdBy: bankAccounts[mapIndex].createdBy,
                        createdOn: bankAccounts[mapIndex].createdOn,
                        ...Object.fromEntries(
                            Object.keys(bankAccounts[mapIndex])
                                .filter(key => key !== 'createdBy' && key !== 'createdOn' && key !== 'reportName')
                                .map(key => [key, null])
                        )
                    };
                    bankAccounts[mapIndex] = updatedAccount;
                }
                // let newextractedData = extractedData[FindIndex].splice(FindIndex, 1);
                console.log("NEW EXTRACTED DATA FIND INDEX", _extractedData);
                dispatch(setExtractedData(_extractedData))
            }
            // }

            setFiles((prev) => {
                return ({
                    ...prev,
                    acceptedFiles: prev.acceptedFiles.filter((item, index) => index !== fileIndex)
                })
            })

            setCurrentFiles((prev) => {
                return prev.filter((item, index) => index !== fileIndex)
            })
        }
        console.log("Delete clicked", files, bankAccounts);
        form.setFieldsValue({ bankAccounts });
        // setFiles([])
        // setCurrentFiles([]);
    }

    console.log('files', files);


    const handleDrop = async (acceptedFiles) => {
        // Preserve previously accepted files using a local variable
        console.log("acceptedFiles on handleDrop", acceptedFiles, files);

        setAcceptedFiles(acceptedFiles);

        const previousAcceptedFiles = files?.acceptedFiles || [];
        setFiles((prev) => ({
            ...prev,
            acceptedFiles: [...previousAcceptedFiles, ...acceptedFiles],
        }));
        setCurrentFiles(acceptedFiles);

        let timer = setTimeout(() => {
            dispatch(setExtractedDataError("Request Timeout"));
            return;
        }, 120000);

        dispatch(setExtractedDataLoading(true));
        const promisList = [];
        const passwordNeeded = [];
        const updatedAcceptedFiles = [...previousAcceptedFiles];

        for (let i = 0; i < acceptedFiles.length; i++) {
            const formData = new FormData();
            formData.append(`file`, acceptedFiles[i]);
            promisList.push(
                extractFileDetails('', formData).then((response) => {
                    console.log("RESPONSE OF EXTRACTFILES::..>", response);

                    // Check if password is needed and update the acceptedFiles object
                    const isPasswordNeeded = response[0].statusCode === 2;
                    console.log("");

                    if (isPasswordNeeded) {
                        passwordNeeded.push(acceptedFiles[i].name);
                    }

                    // Add file information to the updatedAcceptedFiles array
                    updatedAcceptedFiles.push({
                        file: acceptedFiles[i],
                        isPasswordNeeded,
                        password: ''
                    });

                    return response;
                })
            );
        }

        console.log("PROMISELIST", promisList, updatedAcceptedFiles);

        try {
            const allResponses = await Promise.all(promisList);
            console.log("ALL RESPONSES", allResponses);

            dispatch(setExtractedDataLoading(false));
            clearTimeout(timer);

            let _extractedData = files?.extractedData || [];

            console.log("EXTRACTED DATALOG [A]", extractedData, files);

            if (extractedData) {
                _extractedData = [..._extractedData, ...extractedData];
            }

            console.log("EXTRACTED DATALOG [B]", _extractedData);
            for (let index = 0; index < allResponses.length; index++) {
                let findIndex = _extractedData.findIndex((item) => item.mapIndex === mapIndex);
                if (findIndex >= 0) {
                    const newUploadedFiles = [
                        ..._extractedData[findIndex].uploadedFiles,
                        {
                            path: acceptedFiles[index],
                            isPasswordNeeded: updatedAcceptedFiles.find(file => file.file === acceptedFiles[index].name)?.isPasswordNeeded || false,
                        },
                    ];
                    _extractedData[findIndex] = {
                        ..._extractedData[findIndex],
                        uploadedFiles: newUploadedFiles,
                    };
                } else {
                    _extractedData.push({
                        ...allResponses[index],
                        uploadedFiles: [{
                            path: acceptedFiles[index],
                            isPasswordNeeded: updatedAcceptedFiles.find(file => file.file === acceptedFiles[index].name)?.isPasswordNeeded || false,
                        }],
                        mapIndex: mapIndex
                    });
                }
            }


            // const extractedData = [
            //     ...(files?.extractedData || []), // Retain previously extracted data
            //     ...allResponses.map((res) => ({
            //         ...res,
            //         uploadedFiles: [
            //             ...previousAcceptedFiles.map((file) => file), // Include previously accepted files
            //             ...acceptedFiles.map((file) => file), // Include newly accepted files
            //         ],
            //         mapIndex: mapIndex,
            //     })),
            // ];

            console.log("EXTRACTED DATA", extractedData, _extractedData);

            dispatch(setExtractedData(_extractedData));
            dispatch(showNotification({ message: "File uploaded successfully", type: "success", duration: 2 }));

        } catch (error) {
            console.log("ERROR", error);
            dispatch(setExtractedDataError(error.message));
            dispatch(setExtractedDataLoading(false));
            clearTimeout(timer);
            dispatch(showNotification({ message: error.message, type: "error" }));
        }

        console.log("BEFORE SETTER::>>", updatedAcceptedFiles);


        setFiles((prev) => ({
            ...prev,
            acceptedFiles: updatedAcceptedFiles,
        }));

        setPasswordRequiredFiles(passwordNeeded);
    };

    console.log("NESTED UPLOAD", files, files?.acceptedFiles.filter((item) => item.isPasswordNeeded === true).length);


    const handleSubmitPassword = async (fileName) => {
        console.log("acceptedFiles on Handle submit", acceptedFiles, files);

        setAcceptedFiles(acceptedFiles);
        setSubmittedPasswords(prev => new Set([...prev, fileName]));

        const previousAcceptedFiles = passwordFiles?.acceptedFiles || [];
        setPasswordFiles((prev) => ({
            ...prev,
            acceptedFiles: [...previousAcceptedFiles, ...acceptedFiles],
        }));
        setCurrentFiles(acceptedFiles);

        // let timer = setTimeout(() => {
        //     dispatch(setExtractedDataError("Request Timeout"));
        //     return;
        // }, 120000);

        let promisList = [];
        let response;

        files?.acceptedFiles?.forEach(async (element, index) => {
            console.log("passwordFiles", passwordFiles);



            const formData = new FormData();
            // formData.append(`file`, acceptedFiles[i]);

            let password = element?.password || '';
            console.log("Password OF PDF:", password);

            formData.append(`file`, element?.file);
            response = extractFileDetails(password, formData);

            console.log("RESPONSE OF API", response);

            promisList.push(response);
        });
        // for (let i = 0; i < acceptedFiles.length; i++) {
        //     console.log("passwordFiles", passwordFiles);



        //     const formData = new FormData();
        //     // formData.append(`file`, acceptedFiles[i]);

        //     let password = passwords[files?.acceptedFiles[i].name] || '';
        //     console.log("Password OF PDF:", password);

        //     formData.append(`file`, acceptedFiles[i]);
        //     response = await extractFileDetails(password, formData);
        //     console.log("RESPONSE OF API", response);

        //     promisList.push(response);


        // }
        try {
            dispatch(setExtractedDataLoading(true));

            console.log("PROMISLIST", promisList);


            const allResponses = await Promise.all(promisList);
            console.log("ALL RESPONSES", allResponses);
            // clearTimeout(timer);

            // const extractedData = promisList.map(res => ({
            //     ...res,
            //     mapIndex: mapIndex,
            // })).map(data => {
            //     if (data["0"]) {
            //         data["0"].password = password; // Add the password key
            //     }
            //     return data;
            // });

            console.log("EXTRACTED DATALOG 1", extractedData, files);


            let _extractedData = passwordFiles?.extractedData || [];
            if (extractedData) {
                _extractedData = [..._extractedData];
            }

            console.log("EXTRACTED DATALOG 2", _extractedData);


            for (let index = 0; index < allResponses.length; index++) {
                let findIndex = _extractedData.findIndex((item) => item.mapIndex === mapIndex);
                console.log("FIND INDEX::", findIndex,);

                if (findIndex >= 0) {
                    const newUploadedFiles = [
                        ..._extractedData[findIndex].uploadedFiles,
                        {
                            path: acceptedFiles[index],
                            isPasswordNeeded: files?.acceptedFiles?.find(file => file.file === acceptedFiles[index].name)?.isPasswordNeeded || false,
                            password: files?.acceptedFiles?.find(file => file.file.path === acceptedFiles[index].name)?.password || "",
                        },
                    ];
                    _extractedData[findIndex] = {
                        ..._extractedData[findIndex],
                        uploadedFiles: newUploadedFiles,
                    };
                } else {
                    _extractedData.push({
                        ...allResponses[index],
                        uploadedFiles: [{
                            path: acceptedFiles[index],
                            isPasswordNeeded: files?.acceptedFiles?.find(file => file.file === acceptedFiles[index].name)?.isPasswordNeeded || false,
                            password: files?.acceptedFiles?.find(file => file.file.path === acceptedFiles[index].name)?.password || "",
                        }],
                        mapIndex: mapIndex
                    });
                }
            }

            // const extractedData = [
            //     ...(files?.extractedData || []), // Retain previously extracted data
            //     ...allResponses.map((res) => ({
            //         ...res,
            //         uploadedFiles: [
            //             ...previousAcceptedFiles.map((file) => file), // Include previously accepted files
            //             ...acceptedFiles.map((file) => file), // Include newly accepted files
            //         ],
            //         mapIndex: mapIndex,
            //     })),
            // ];

            console.log("EXTRACTED DATA", extractedData, _extractedData);

            dispatch(setExtractedData(_extractedData));


            // dispatch(setExtractedData(extractedData));
            allResponses?.forEach(element => {
                if (element[0].statusCode === 2) {
                    setShowPasswordMsg(false);
                    dispatch(showNotification({ message: "You entered wrong password!", type: "warning", duration: 2 }));
                } else {
                    setShowPasswordMsg(true);
                    dispatch(showNotification({ message: "Data extracted successfully!", type: "success", duration: 2 }));
                }

            });

            // console.log("PASS RESPONSE ::..>>", response[0]?.statusCode, extractedData);
            // setShowPasswordMsg(false);
            dispatch(setExtractedDataLoading(false));
        } catch (error) {
            console.log("error", error);
            dispatch(setExtractedDataError(error.message));
            dispatch(setExtractedDataLoading(false));
            dispatch(showNotification({ message: error.message, type: "error" }));
        }
        setPasswordRequiredFiles([])

        // await Promise.all(promisList).catch((error) => {
        //     console.log(error);
        //     dispatch(setExtractedDataError(error.message));
        // });
    };

    const getFile = () => {
        console.log("files", files);
        return (
            files?.acceptedFiles?.length > 0 ? (
                files?.acceptedFiles?.map((file, index) => {
                    return (<>
                        <Flex className="pt-8" gap={3} key={index}>
                            <PaperClipOutlined style={{ fontSize: "18px" }} />
                            <Space align="center">
                                <CustomTypography
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 400,
                                        lineHeight: "33x",
                                        color: "#1677FF",
                                        fontFamily: "Satoshi"
                                    }}
                                >
                                    {file?.file?.name}
                                </CustomTypography>

                                {(file.isPasswordNeeded === true && !showPasswordMsg) && (
                                    <>
                                        <Form.Item
                                            style={{ margin: '0px' }}
                                            // className='w-100'
                                            name={[name, "password", file?.file.name]} // Use unique name for each file input
                                            {...restField}
                                            required={false}
                                            rules={[{ required: true, message: "Please enter file password." }]}
                                        >
                                            <Input
                                                key={file?.file.name}
                                                autoComplete={false}
                                                name={`password${index}`}
                                                type="password"
                                                value={passwords[file?.file.name] || ""} // Value tied to specific file name
                                                onChange={(e) => handlePasswordChange(e, file?.file.name, index)} // Handle change per file
                                                placeholder={`Enter Password for ${file?.file.name}`}
                                            />
                                        </Form.Item>
                                    </>
                                )}

                                <DeleteOutlined style={{ color: '#fa0205' }} onClick={() => handleDelete(index)} />
                            </Space>
                        </Flex>
                    </>
                    )
                })
            ) : (
                <Flex className="pt-8" gap={3}>
                    <PaperClipOutlined style={{ fontSize: "18px" }} />
                    <CustomTypography
                        style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            lineHeight: "22px",
                            color: "#1677FF",
                            fontFamily: "Satoshi"
                        }}
                    >
                        No files uploaded
                    </CustomTypography>
                </Flex>
            )
        );
    };


    console.log("FLAG INDICATIONS", showPasswordMsg)

    return (
        <>
            <Form.Item
                className='w-100'
                name={[name, "upload"]}
                // valuePropName="fileList"
                // getValueFromEvent={e => e}
                {...restField}
                required={false}
                rules={[{ required: true, message: "Please Upload your Bank Statement" }]}
            >
                <Flex vertical gap={8}>
                    <Row>
                        <Col lg={24}>
                            <Dropzone form={form} isEdit={isEdit} setFiles={setFiles} mapIndex={mapIndex} setCurrentFiles={setCurrentFiles} reset={resetFields} remove={remove} name={name} multiple={true} files={files} handleDrop={handleDrop} />
                            <br />
                        </Col>
                    </Row>
                    <>
                        <>
                            {
                                uploadFile.map((item, index) => (
                                    <Flex className="pt-8" gap={3} key={index}>
                                        <PaperClipOutlined style={{ fontSize: "18px" }} />
                                        <Space>
                                            <CustomTypography
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: 400,
                                                    lineHeight: "22px",
                                                    color: "#1677FF",
                                                    fontFamily: "Satoshi"
                                                }}
                                            >{item.originalName}</CustomTypography>
                                            {!isEdit && (<DeleteOutlined disabled={true} style={{ color: '#b0acac' }} />)}
                                        </Space>
                                    </Flex>
                                ))
                            }
                        </>
                        {
                            (Object.keys(files?.acceptedFiles || []).length > 0) && <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0px'
                            }}>{getFile()}</div>
                        }
                    </>
                    {
                        ((analysedUploadedFiles && analysedUploadedFiles[mapIndex]?.length > 0) && isEdit) && (
                            <Row style={{ marginTop: "24px" }}>
                                <Col lg={24}>
                                    <Table tableLayout="fixed" dataSource={analysedUploadedFiles ? analysedUploadedFiles[mapIndex] : dataSources} columns={columns} scroll={{
                                        x: 700, // Enables horizontal scrolling when the content exceeds the container width
                                        y: 200, // Sets a fixed height for the table, enabling vertical scrolling
                                    }} pagination={false}
                                    />
                                </Col>
                            </Row>
                        )
                    }
                </Flex>
            </Form.Item>
            {(files?.acceptedFiles.filter((item) => item.isPasswordNeeded === true).length > 0 && !showPasswordMsg) && (
                <>
                    {/* {files?.acceptedFiles.map((file, i) => (
                        (passwordRequiredFiles.includes(file?.file.name) && !submittedPasswords.has(file?.file.name)) && (
                        <div key={i}>
                            <br />
                            <CustomTypography>Enter Password</CustomTypography>
                            <Form.Item
                                className='w-100'
                                name={[name, "password", file?.file.name]} // Use unique name for each file input
                                {...restField}
                                required={false}
                                rules={[{ required: true, message: "Please enter file password." }]}
                            >
                                <CustomInput
                                    key={file?.file.name}
                                    type="password"
                                    value={passwords[file?.file.name] || ""} // Value tied to specific file name
                                    onChange={(e) => handlePasswordChange(e, file?.file.name)} // Handle change per file
                                    placeholder={`Enter Password for ${file?.file.name}`}
                                />
                            </Form.Item>
                        </div>
                        )
                    ))} */}
                    <CustomButton type="primary" onClick={() => handleSubmitPassword()}>Submit Password</CustomButton>
                </>
            )}
        </>
    );
};

export default UploadBankStatementForm;